// extracted by mini-css-extract-plugin
module.exports = {"modal":"RemoveUserModal_modal__37VNs","close":"RemoveUserModal_close__3o1QL","buttons":"RemoveUserModal_buttons__FMOOT","button":"RemoveUserModal_button__3j0XM"};